<template>
    <div class="swiper-button-prev" :class="prevClass">
        <svg
            width="22"
            height="40"
            viewBox="0 0 18 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.3652 29.7305L2.00049 15.3657L16.3652 1.00098"
                stroke="#e41a4b"
                stroke-width="3"
                stroke-linecap="round"
            />
        </svg>

        <div class="animated_arrow left_arrow">
            <span></span>
            <span></span>
        </div>
    </div>
    <div class="swiper-button-next" :class="nextClass">
        <svg
            width="22"
            height="40"
            viewBox="0 0 18 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.36523 1L15.73 15.3647L1.36523 29.7295"
                stroke="#e41a4b"
                stroke-width="3"
                stroke-linecap="round"
            />
        </svg>

        <div class="animated_arrow right_arrow">
            <span></span>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        prevClass: {
            type: String
        },
        nextClass: {
            type: String
        }
    }
};
</script>
<style scoped lang="scss">
@import "swiper/css/navigation";
.swiper {
    &-button {
        &-next,
        &-prev {
            height: 100%;
            width: 60px;
            border: none;
            top: 0;
            opacity: 0;
            margin: 0;
            transition: 0.3s;
            &::after {
                display: none;
            }
            svg {
                width: 22px;
                height: 40px;
                z-index: 4;
                position: relative;
            }
            &.swiper-button-disabled {
                opacity: 0;
            }
            .animated_arrow {
                opacity: 0;
                z-index: 4;
                position: relative;
                span {
                    display: block;
                    width: 28px;
                    height: 28px;
                    border-bottom: 4px solid #e41a4b;
                    border-right: 4px solid #e41a4b;
                    transform: rotate(45deg);
                    margin: -13px;
                    border-radius: 3px;
                }
            }
            &:hover {
                svg {
                    opacity: 0;
                }
                .animated_arrow {
                    opacity: 1;
                    span {
                        animation: animate 1.2s infinite;
                        &:nth-child(1) {
                            animation-delay: -0.2s;
                        }
                        &:nth-child(2) {
                            animation-delay: -0.4s;
                        }
                    }
                }
            }
        }
        &-next {
            // padding-left: 70px;
            background: none;
            &::before {
                position: absolute;
                right: 0;
                content: "";
                width: 130px;
                height: 100%;
                z-index: 1;
                pointer-events: none;
                background: linear-gradient(
                    90deg,
                    #ffffff00 0%,
                    #00000025 20%,
                    #00000085 45%,
                    #000000b4 65%,
                    #000000e1 95%
                );
            }
            .animated_arrow {
                transform: rotate(270deg) translateY(-150%);
            }
        }










        
        &-prev {
            // padding-right: 70px;
            background: none;
            &::before {
                position: absolute;
                left: 0;
                content: "";
                width: 130px;
                height: 100%;
                z-index: 1;
                pointer-events: none;
                background: linear-gradient(
                    270deg,
                    #ffffff00 0%,
                    #00000025 20%,
                    #00000085 45%,
                    #000000b4 65%,
                    #000000e1 95%
                );
            }
            .animated_arrow {
                transform: rotate(90deg) translateY(-50%);
            }
        }
    }
    &:hover {
        .swiper-button-next,
        .swiper-button-prev {
            opacity: 1;
            &.swiper-button-disabled {
                opacity: 0;
            }
        }
    }
}
@keyframes animate {
    0% {
        opacity: 0;
        transform: rotate(45deg) translate(-20px, -20px);
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: rotate(45deg) translate(20px, 20px);
    }
}
@media screen and (max-width: 991.98px) {
    .swiper-button-next,
    .swiper-button-prev {
        display: none;
    }
}
</style>
